import { Serializable } from "../utilities/Serializable";

export class UnitOfMeasure extends Serializable {
    uuid: string;
    description: string;
    symbol: string;
}


// WEBPACK FOOTER //
// ./src/app/models/UnitOfMeasure.ts